import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useGetAllDisputesQuery, DisputeModel } from '../../../../../../../../redux/services/MerchantApi';
import { Table } from '../../../../../../../../components/Table/Table';
import { Pagination } from '../../../../../../../../components/Pagination/Pagination';
import styles from '../content.module.css';
import { disputeArray } from '../../../../../../../../utils/constants/th_arrays';
import { SearchContainer, SearchLabel, Input } from './styles';
const pageSize = 7;
import { statusesTranslate } from '../../statuses';
import { type CSSProperties } from 'react';
const linkStyle: CSSProperties = {
      cursor: 'pointer',
      color: 'blue',
      textDecoration: 'none',
    };
export const DisputesTable: React.FC = () => {
  const navigate = useNavigate();
  const { data = [], isLoading, error } = useGetAllDisputesQuery(
    undefined,
    { pollingInterval: 10000 }
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [highlightId, setHighlightId] = useState<string | null>(null);

  useEffect(() => {
      const highlight = searchParams.get('highlight');
      if (highlight) {
        setHighlightId(highlight);
        searchParams.delete('highlight');
        setSearchParams(searchParams);
      }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (highlightId && data.length) {
      const found = data.find(d => String(d.id) === highlightId);
      if (found) {
        setActiveTab(found.status === 'in_dispute' ? 'open' : 'resolved');
      }
    }
  }, [highlightId, data]);

  const [activeTab, setActiveTab] = useState<'open' | 'resolved'>('open');
  const [filter, setFilter] = useState('');
  const [page, setPage] = useState(1);

  if (isLoading) return <div>Загрузка споров...</div>;
  if (error) return <div>Ошибка загрузки споров</div>;

  // 1) Фильтр по табу
  let filtered = data.filter(d =>
    activeTab === 'open'
      ? d.status === 'ID'
      : d.status !== 'ID'
  );

  if (highlightId) {
    filtered = filtered.sort((a, b) =>
      String(a.id) === highlightId ? -1 :
      String(b.id) === highlightId ?  1 : 0
    );
  }
  // 2) Фильтр по order или withdrawal
  if (filter.trim()) {
    const f = filter.trim().toLowerCase();
    filtered = filtered.filter(d =>
      String(d.order).toLowerCase().includes(f) ||
      String(d.withdrawal ?? '').toLowerCase().includes(f)
    );
  }


  // 3) Пагинация
  const totalPages = Math.ceil(filtered.length / pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages || 1);
  const paged = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

    const tdArray = paged.map((d: DisputeModel) => {
      const isHighlighted = highlightId === String(d.id);
      return [
        { element: d.id, style: undefined },
        {
          element: (
            <a
              style={linkStyle}
              onClick={() => {
                  const page = 1
                  navigate(`/merchant/applications?highlight=${d.order}&page=${page}`)
              }}
            >
              {d.order}
            </a>

          ),
          style: undefined,
        },
        {
          element: (
            <a
              style={linkStyle}
              onClick={() => {
                  const page = 1
                  navigate(`/merchant/applications?highlight=${d.withdrawal}&page=${page}`)
              }}
            >
              {d.withdrawal}
            </a>

          ),
          style: undefined,
        },
        { element: d.summa, style: undefined },
        { element: d.comment, style: undefined },
        { element: statusesTranslate[d.status] ?? d.status, style: undefined },
        { element: new Date(d.create_dt).toLocaleString(), style: undefined },
      ].map((cell) => ({
        ...cell,
        style: isHighlighted ? { backgroundColor: '#d0ebff' } : cell.style,
      }));
    });
  return (
    <div>
      <div className={styles.tabs}>
        <button
        className={`${styles.tab} ${
          activeTab === 'open' ? styles.activeTab : ''
        }`}
          onClick={() => { setActiveTab('open'); setPage(1); }}
        >
          Открытые
        </button>
        <button
        className={`${styles.tab} ${
          activeTab === 'resolved' ? styles.activeTab : ''
        }`}
          onClick={() => { setActiveTab('resolved'); setPage(1); }}
        >
          Решённые
        </button>
      </div>
      <SearchContainer>
      <Input
        className={styles.filterInput}
        type="text"
        placeholder="Поиск"
        value={filter}
        onChange={e => { setFilter(e.target.value); setPage(1); }}
      />
      </SearchContainer>
      {filtered.length === 0 ? (
        <div>На данный момент нет подходящих споров...</div>
      ) : (
        <>
          <Table tableId='merchant-disputes' thArray={disputeArray} tdArray={tdArray} />
          <Pagination
            totalPages={totalPages}
            currentPage={safePage}
            setCurrentPage={setPage}
            nextPage={Math.min(safePage + 1, totalPages)}
            previousPage={Math.max(safePage - 1, 1)}
          />
        </>
      )}
    </div>
  );
};

export default DisputesTable;
